import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0c83820&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b0c83820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c83820",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Empty: require('/drone/src/components/Empty/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default})
